import { useMemo } from 'react'
import { calculateNetSeller } from '@almaris/shared/helpers/calculateNetSeller'

export interface UseNetSellerParams {
  offerAmount: number | null
  fixedFee: number
  proportionalFeesRate: number
  feeVATRate: number
  fixedFeeThreshold: number
}

export const useNetSeller = ({
  offerAmount,
  fixedFee,
  proportionalFeesRate,
  feeVATRate,
  fixedFeeThreshold,
}: UseNetSellerParams) => {
  return useMemo(() => {
    return calculateNetSeller(
      offerAmount ?? 0,
      fixedFee,
      proportionalFeesRate,
      feeVATRate,
      fixedFeeThreshold
    )
  }, [
    offerAmount,
    fixedFee,
    proportionalFeesRate,
    feeVATRate,
    fixedFeeThreshold,
  ])
}
